import { Fragment } from 'react'
import { ReactComponent as FlowArrow } from '~/assets/images/flow-arrow.svg'
import { StyledTradeFlow } from './styled'

export interface ITradeFlow {
  flow?: Array<{
    token: BaseTokenlonToken
    amount: string | number
  }>
}

export const TradeFlow: React.FC<ITradeFlow> = ({ flow }) => {
  if (!flow.length) return null

  return (
    <StyledTradeFlow>
      {flow.map(({ amount, token }, index) => (
        <Fragment key={token.address}>
          <span>
            {amount}
            {token.symbol}
          </span>
          {index === flow.length - 1 ? null : <FlowArrow />}
        </Fragment>
      ))}
    </StyledTradeFlow>
  )
}
